const reloadPage = (event, injectedWindow = window) => injectedWindow.location.reload();

export default reloadPage;
